import { Box } from "@chakra-ui/react";
import blink from "src/styling/animations/blink";
import { getAppValue } from "src/utils/environment";

export default function BlinkingDot({
  top = ["3px", "4px", "6px"],
  left = ["-16px", "-20px", "-22px"],
  p = ["4px", "6px", "7px"],
  bg = getAppValue({ barkio: "primary", bibino: "secondary" })
}) {
  return (
    <Box
      as="span"
      pos="absolute"
      borderRadius="100%"
      animation={`${blink} 2.4s ease-in-out infinite`}
      p={p}
      bg={bg}
      top={top}
      left={left}
    />
  );
}
